import orderBy from 'lodash/orderBy'

export const orderBySource = (data: any) => {
  const _data = orderBy(data, ['firstWord'], ['asc'])
  const _setOptions = _data.reduce((_: any, o: any) => {
    !_[o.firstWord] ? (_[o.firstWord] = [o]) : _[o.firstWord].push(o)
    return _
  }, {})
  return _setOptions
}